import { BeanMonitoryCommentReply } from 'src/bean/BeanMonitoryCommentReply';
import { BeanAnswer } from './BeanAnswer';
import { BeanCategory } from './BeanCategory';
import { BeanCategoryGroup } from './BeanCategoryGroup';
import{BeanContestation} from './BeanContestation'
import { BeanQuestion } from './BeanQuestion';
import { BeanUsuario } from './BeanUsuario';

export class BeanMonitoryQuestionAnswer{
  constructor(
    public permNrSequencia: number,
    public moniIdCdMonitoria :number,
    public grcaIdCdGrupoCategoria :number,
    public cateIdCdCategoria :number,
    public pergIdCdPergunta :number,
    public respIdCdResposta :number,
    public usuaIdCdUsuario :number,
    public contestations: BeanContestation[]=[],
    public comment: BeanMonitoryCommentReply,
    public categoryGroup: BeanCategoryGroup,
    public category: BeanCategory,
    public question: BeanQuestion,
    public answer: BeanAnswer,
    public user: BeanUsuario,
    public pereNrPonto :string,
    public pereNrPontoExtra :string
    

  ){}
}
